import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import CurrencyForm from "../form";

const UpdateCurrency = () => {
  const { currencyId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Currency" />
      <div className="p-6 max-w-2xl">
        <CurrencyForm currencyId={currencyId} />
      </div>
    </div>
  );
};

export default UpdateCurrency;
